import { type RouteConfig, RouterView } from 'vue-router'

export default [

    {
        path: '/tablero-control/dashboard',
        name: 'tablero-control-general',
        component: () => import('@/views/pages/tableroControl/dashboard.vue'),
        meta: {
			title: 'i18n:',
            action: 'ver-tablero-control-dashboard-general',
            breadcrumb: [
                {
                    text: 'tablero.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.general.menu_title',
                },
            ],
        },
    },
    {
        path: '/tablero-control/comercio-exterior/exportaciones/',
        name: 'tablero-control-comercio-exterior-exportaciones',
        component: () => import('@/views/pages/tableroControl/dashboardGenerico.vue'),
        meta: {
			title: 'i18n:',
            action: 'ver-tablero-control-comercio-exterior-exportaciones',
            dashboardName: 'DASHBOARD EXPORTACIONES',
            breadcrumb: [
                {
                    text: 'tablero.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.comercio_exterior.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.comercio_exterior.menu_exportaciones',
                },
            ],
        },
    },
    {
        path: '/tablero-control/comercio-exterior/ventas-por-cliente',
        name: 'tablero-control-comercio-exterior-venta-por-cliente',
        component: () => import('@/views/pages/tableroControl/dashboardGenerico.vue'),
        meta: {
			title: 'i18n:',
            action: 'ver-tablero-control-comercio-exterior-venta-por-cliente',
            dashboardName: 'DASHBOARD VENTAS POR CLIENTES',
            breadcrumb: [
                {
                    text: 'tablero.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.comercio_exterior.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.comercio_exterior.menu_vta_x_cliente',
                },
            ],
        },
    },
    {
        path: '/tablero-control/comercio-exterior/ventas-por-mercado',
        name: 'tablero-control-comercio-exterior-venta-por-mercado',
        component: () => import('@/views/pages/tableroControl/dashboardGenerico.vue'),
        meta: {
			title: 'i18n:',
            action: 'ver-tablero-control-comercio-exterior-venta-por-mercado',
            dashboardName: 'DASHBOARD VENTAS POR MERCADO',
            breadcrumb: [
                {
                    text: 'tablero.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.comercio_exterior.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.comercio_exterior.menu_vta_x_mercado',
                },
            ],
        },
    },
    {
        path: '/tablero-control/tributario/ingreso-vs-egresos',
        name: 'tablero-control-tributario-ingreso-vs-egresos',
        component: () => import('@/views/pages/tableroControl/dashboardGenerico.vue'),
        meta: {
			title: 'i18n:',
            action: 'ver-tablero-control-tributario-ingreso-egreso',
            dashboardName: 'DASHBOARD DETALLE INGRESO VS EGRESO',
            breadcrumb: [
                {
                    text: 'tablero.menu_title',
                    active: true,
                },
                {
                    text: 'tablero.ingreso_tributario.menu_title',
                },
            ],
        },
    },

] as RouteConfig[]
